import sliceCreator from '../../index.js';
import {GET_RAW_MATERIALS_BY_MACHINE} from '../../../constants/index.js';
const _getrawMaterialMachineMappingAction = sliceCreator('GET_RAW_MATERIALS_BY_MACHINE', GET_RAW_MATERIALS_BY_MACHINE, 'get');

const { asyncAction: getRawMaterialMachineMappingAction, reducer, clearData: clearGetRawMaterialMachineMappingAction } = _getrawMaterialMachineMappingAction;

export default reducer;

export {
    getRawMaterialMachineMappingAction,
    clearGetRawMaterialMachineMappingAction
}